import { getCurrentLocale, getUnAuthRequest } from '../../../utils'
import { Currency } from './types/currency'

interface CurrenciesResponse {
  currencies?: Currency[] | null
}

export const fetchCurrencies = (): Promise<CurrenciesResponse> => {
  const locale = getCurrentLocale()
  const init = {
    headers: {
      'Accept-Language': locale,
    },
  }

  return getUnAuthRequest('/v2/currencies', init)
}
